// Count items in marquee and update css animation duration based on the number of items.
window.addEventListener('load', function () {
    var marquees = document.querySelectorAll('.mol-marquee');

    // Loop through each .mol-marquee element
    marquees.forEach(function (marquee, index) {
        var groups = marquee.querySelectorAll('.marquee-group');
        
        var count = 0;
        if (groups.length > 0) {
            count = groups[0].querySelectorAll('.marquee-item').length;
            
            // Calculate the animation duration (8s per item)
            var duration = (count * 8) + 's';
            
            // Set the animation duration on each element
            groups.forEach(function (group) {
                group.style.animationDuration = duration;
            });
        }
    });
});
